import { Collapse as AntCollapse } from "antd"
import { CollapseBlueProvider } from "components/providers/Collapse.provider"
import { CollapseBlueIcon } from "../icons/collapseIcon/CollapseBlueIcon"
import { CollapseGrayIcon } from "../icons/collapseIcon/CollapseGrayIcon"
import type { SizeType } from "antd/es/config-provider/SizeContext"
import type { CollapseProps } from "antd"

// Extend CollapseProps items to allow data-testid
type CollapseItemWithTestId = NonNullable<CollapseProps["items"]>[number] & {
	"data-testid"?: string
}

type Props = {
	items: CollapseItemWithTestId[]
	bordered?: boolean
	size?: SizeType
	ghost?: boolean
	defaultActiveKey?: string | number | (string | number)[] | undefined
	className?: string
	destroyOnHidden?: boolean
}

export const Collapse = ({
	items,
	bordered = false,
	size = "large",
	ghost = true,
	defaultActiveKey,
	className = "",
	destroyOnHidden = true,
}: Props) => {
	return (
		<CollapseBlueProvider>
			<AntCollapse
				items={items}
				bordered={bordered}
				defaultActiveKey={defaultActiveKey}
				size={size}
				ghost={ghost}
				destroyOnHidden={destroyOnHidden}
				className={className}
				expandIcon={({ isActive }) =>
					isActive ? <CollapseBlueIcon rotate={isActive ? 90 : 0} /> : <CollapseGrayIcon rotate={isActive ? 90 : 0} />
				}
			/>
		</CollapseBlueProvider>
	)
}
